module.exports = __webpack_public_path__ + "static/media/lifeline_step_3.db6c3766.png";